const GOOGLE_TAG_MANAGER_BASE_URL = 'https://www.googletagmanager.com'

export const getGoogleTagManagerId = (): string | null => {
  const googleTagManagerId = process.env.NEXT_PUBLIC_GTM_ID?.trim()

  return googleTagManagerId ? googleTagManagerId : null
}

export const buildGoogleTagManagerScript = (googleTagManagerId: string): string => {
  return `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    '${GOOGLE_TAG_MANAGER_BASE_URL}/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer',${JSON.stringify(googleTagManagerId)});
  `.trim()
}

export const getGoogleTagManagerNoscriptUrl = (googleTagManagerId: string): string => {
  return `${GOOGLE_TAG_MANAGER_BASE_URL}/ns.html?id=${googleTagManagerId}`
}
